import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/home/Home';
import Login from '@/views/login/Login';
import DistributorList from '@/views/distributor/DistributorList';
import DistributorDetail from '@/views/distributor/DistributorDetail';
import DistributorEditor from '@/views/distributor/DistributorEditor';
import SubdistributorList from '@/views/subdistributor/SubdistributorList';
import SubdistributorDetail from '@/views/subdistributor/SubdistributorDetail';
import SubdistributorEditor from '@/views/subdistributor/SubdistributorEditor';
import ChainList from '@/views/chain/ChainList';
import ChainDetail from '@/views/chain/ChainDetail';
import ChainEditor from '@/views/chain/ChainEditor';
import StoreList from '@/views/store/StoreList';
import StoreDetail from '@/views/store/StoreDetail';
import StoreEditor from '@/views/store/StoreEditor';
import UserList from '@/views/user/UserList';
import UserDetail from '@/views/user/UserDetail';
import UserEditor from '@/views/user/UserEditor';
import StaffList from '@/views/staff/StaffList';
import StaffDetail from '@/views/staff/StaffDetail.vue';
import StaffEditor from '@/views/staff/StaffEditor';
import FilmCodeInspector from '@/views/inspectors/FilmCodeInspector';
import VoucherInspector from '@/views/inspectors/VoucherInspector';
import ResetPassword from '@/views/login/ResetPassword';
import ReportsTab from '@/components/tabs/ReportsTab';
import TransactionsTab from '@/components/tabs/TransactionsTab';
import SubdistributorsTab from '@/components/tabs/SubdistributorsTab';
import ChainsTab from '@/components/tabs/ChainsTab';
import StoresTab from '@/components/tabs/StoresTab';
import StaffTab from '@/components/tabs/StaffTab';
import UsersTab from '@/components/tabs/UsersTab';
import AboutTab from '@/components/tabs/AboutTab';
import FourSeasonsTab from '@/components/tabs/FourSeasonsTab';
import InstallsTab from '@/components/tabs/InstallsTab';
import LocationTab from '@/components/tabs/LocationTab';
import StoreAboutTab from '@/components/tabs/StoreAboutTab';
import TemplateTypesTab from '@/components/tabs/TemplateTypesTab';
import ScreensaverListTab from '@/components/tabs/ScreensaverListTab';
import ScreensaverEditorTab from '@/components/tabs/ScreensaverEditorTab';
import DistributorTemplateTypesTab from '@/components/tabs/DistributorTemplateTypesTab';
import EmailTemplatesTab from '@/components/tabs/EmailTemplatesTab';
import ExtendedWarrantyTab from '@/components/tabs/ExtendedWarrantyTab';
import LifetimeWarrantyTab from '@/components/tabs/LifeTimeWarrantyTab';
import DistributorSettingsTab from '@/components/tabs/DistributorSettingsTab';
import DistributorStoreSettingsTab from '@/components/tabs/DistributorStoreSettingsTab';

import auth from '@/services/auth';

import store from '@/store/index';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      public: true,
    },
  },
  {
    path: '/resetpassword',
    name: 'reset-password',
    component: ResetPassword,
    meta: {
      public: true,
    },
  },
  {
    path: '/distributors',
    name: 'distributor-list',
    component: DistributorList,
  },
  {
    path: '/distributors/editor',
    name: 'distributor-editor',
    component: DistributorEditor,
  },
  {
    path: '/distributors/:id',
    name: 'distributor-detail',
    component: DistributorDetail,
    redirect: {
      name: 'distributor-reports-tab',
    },
    children: [
      {
        path: '',
        name: 'distributor-reports-tab',
        component: ReportsTab,
        props: (route) => ({
          distributor_id: route.params.id,
        }),
      },
      {
        path: 'transactions',
        name: 'distributor-transactions-tab',
        component: TransactionsTab,
        props: (route) => ({
          distributor_id: route.params.id,
        }),
      },
      {
        path: 'subdistributors',
        name: 'distributor-subdistributors-tab',
        component: SubdistributorsTab,
      },
      {
        path: 'chains',
        name: 'distributor-chains-tab',
        component: ChainsTab,
      },
      {
        path: 'stores',
        name: 'distributor-stores-tab',
        component: StoresTab,
        props: (route) => ({
          distributor_id: route.params.id,
        }),
      },
      {
        path: 'users',
        name: 'distributor-users-tab',
        component: UsersTab,
        props: (route) => ({
          distributor_id: route.params.id,
        }),
      },
      {
        path: 'extended-warranty',
        name: 'distributor-extended-warranty-tab',
        component: ExtendedWarrantyTab,
        props: (route) => ({
          distributor_id: route.params.id,
        }),
      },
      {
        path: 'lifetime-warranty',
        name: 'distributor-lifetime-warranty-tab',
        component: LifetimeWarrantyTab,
        props: (route) => ({
          distributor_id: route.params.id,
        }),
      },
      {
        path: 'about',
        name: 'distributor-about-tab',
        component: AboutTab,
        props: { section: 'distributors' },
      },
      {
        path: 'settings',
        name: 'distributor-settings-tab',
        component: DistributorSettingsTab,
        props: { section: 'distributors' },
      },
      {
        path: 'store-settings',
        name: 'distributor-store-settings-tab',
        component: DistributorStoreSettingsTab,
        props: { section: 'distributors' },
      },
      {
        path: 'staff',
        name: 'distributor-staff-tab',
        component: StaffTab,
      },
      {
        path: 'template-types',
        name: 'distributor-template-types-tab',
        component: DistributorTemplateTypesTab,
        props: { section: 'distributors' },
      },
      {
        path: 'email-templates',
        name: 'distributor-email-templates-tab',
        component: EmailTemplatesTab,
        props: {},
      },
      {
        path: 'screensavers',
        name: 'distributor-screensavers-list-tab',
        component: ScreensaverListTab,
        props: { section: 'distributors' },
      },
      {
        path: 'screensavers/editor',
        name: 'distributor-screensavers-editor-tab',
        component: ScreensaverEditorTab,
        props: { section: 'distributors' },
      },
    ],
  },
  {
    path: '/subdistributors',
    name: 'subdistributor-list',
    component: SubdistributorList,
  },
  {
    path: '/subdistributors/editor',
    name: 'subdistributor-editor',
    component: SubdistributorEditor,
  },
  {
    path: '/subdistributors/:id',
    name: 'subdistributor-detail',
    component: SubdistributorDetail,
    redirect: {
      name: 'subdistributor-reports-tab',
    },
    children: [
      {
        path: '',
        name: 'subdistributor-reports-tab',
        component: ReportsTab,
        props: (route) => ({
          subdistributor_id: route.params.id,
        }),
      },
      {
        path: 'transactions',
        name: 'subdistributor-transactions-tab',
        component: TransactionsTab,
        props: (route) => ({
          subdistributor_id: route.params.id,
        }),
      },
      {
        path: 'chains',
        name: 'subdistributor-chains-tab',
        component: ChainsTab,
      },
      {
        path: 'stores',
        name: 'subdistributor-stores-tab',
        component: StoresTab,
        props: (route) => ({
          subdistributor_id: route.params.id,
        }),
      },
      {
        path: 'users',
        name: 'subdistributor-users-tab',
        component: UsersTab,
        props: (route) => ({
          subdistributor_id: route.params.id,
        }),
      },
      {
        path: 'extended-warranty',
        name: 'subdistributor-extended-warranty-tab',
        component: ExtendedWarrantyTab,
        props: (route) => ({
          subdistributor_id: route.params.id,
        }),
      },
      {
        path: 'lifetime-warranty',
        name: 'subdistributor-lifetime-warranty-tab',
        component: LifetimeWarrantyTab,
        props: (route) => ({
          subdistributor_id: route.params.id,
        }),
      },
      {
        path: 'about',
        name: 'subdistributor-about-tab',
        component: AboutTab,
        props: {
          section: 'subdistributors',
        },
      },
      {
        path: 'settings',
        name: 'subdistributor-settings-tab',
        component: DistributorSettingsTab,
        props: { section: 'subdistributors' },
      },
      {
        path: 'store-settings',
        name: 'subdistributor-store-settings-tab',
        component: DistributorStoreSettingsTab,
        props: { section: 'subdistributors' },
      },
      {
        path: 'template-types',
        name: 'subdistributor-template-types-tab',
        component: DistributorTemplateTypesTab,
        props: { section: 'subdistributors' },
      },
      {
        path: 'screensavers',
        name: 'subdistributor-screensavers-list-tab',
        component: ScreensaverListTab,
        props: { section: 'subdistributors' },
      },
      {
        path: 'staff',
        name: 'subdistributor-staff-tab',
        component: StaffTab,
      },
    ],
  },
  {
    path: '/chains',
    name: 'chain-list',
    component: ChainList,
  },
  {
    path: '/chains/editor',
    name: 'chain-editor',
    component: ChainEditor,
  },
  {
    path: '/chains/:id',
    name: 'chain-detail',
    component: ChainDetail,
    redirect: {
      name: 'chain-reports-tab',
    },
    children: [
      {
        path: '',
        name: 'chain-reports-tab',
        component: ReportsTab,
        props: (route) => ({
          chain_id: route.params.id,
        }),
      },
      {
        path: 'transactions',
        name: 'chain-transactions-tab',
        component: TransactionsTab,
        props: (route) => ({
          chain_id: route.params.id,
        }),
      },
      {
        path: 'stores',
        name: 'chain-stores-tab',
        component: StoresTab,
        props: (route) => ({
          chain_id: route.params.id,
        }),
      },
      {
        path: 'users',
        name: 'chain-users-tab',
        component: UsersTab,
        props: (route) => ({
          chain_id: route.params.id,
        }),
      },
      {
        path: 'template-types',
        name: 'chain-template-types-tab',
        component: TemplateTypesTab,
        props: (route) => ({
          chain_id: route.params.id,
        }),
      },
      {
        path: 'extended-warranty',
        name: 'chain-extended-warranty-tab',
        component: ExtendedWarrantyTab,
        props: (route) => ({
          chain_id: route.params.id,
        }),
      },
      {
        path: 'lifetime-warranty',
        name: 'chain-lifetime-warranty-tab',
        component: LifetimeWarrantyTab,
        props: (route) => ({
          chain_id: route.params.id,
        }),
      },
      {
        path: 'four-seasons',
        name: 'chain-four-seasons-tab',
        component: FourSeasonsTab,
      },
      {
        path: 'about',
        name: 'chain-about-tab',
        component: AboutTab,
        props: {
          section: 'chains',
        },
      },
      {
        path: 'store-settings',
        name: 'chain-store-settings-tab',
        component: DistributorStoreSettingsTab,
        props: { section: 'chains' },
      },
      {
        path: 'staff',
        name: 'chain-staff-tab',
        component: StaffTab,
      },
    ],
  },
  {
    path: '/stores',
    name: 'store-list',
    component: StoreList,
  },
  {
    path: '/stores/editor',
    name: 'store-editor',
    component: StoreEditor,
  },
  {
    path: '/stores/:id',
    name: 'store-detail',
    component: StoreDetail,
    redirect: {
      name: 'store-reports-tab',
    },
    children: [
      {
        path: '',
        name: 'store-reports-tab',
        component: ReportsTab,
        props: (route) => ({
          store_id: route.params.id,
        }),
      },
      {
        path: 'transactions',
        name: 'store-transactions-tab',
        component: TransactionsTab,
        props: (route) => ({
          store_id: route.params.id,
        }),
      },
      {
        path: 'installs',
        name: 'store-installs-tab',
        component: InstallsTab,
      },
      {
        path: 'users',
        name: 'store-users-tab',
        component: UsersTab,
        props: (route) => ({
          store_id: route.params.id,
        }),
      },
      {
        path: 'location',
        name: 'store-location-tab',
        component: LocationTab,
      },
      {
        path: 'about',
        name: 'store-about-tab',
        component: StoreAboutTab,
      },
      {
        path: 'staff',
        name: 'store-staff-tab',
        component: StaffTab,
      },
    ],
  },
  {
    path: '/users',
    name: 'user-list',
    component: UserList,
  },
  {
    path: '/users/editor',
    name: 'user-editor',
    component: UserEditor,
  },
  {
    path: '/users/:id',
    name: 'user-detail',
    component: UserDetail,
  },
  {
    path: '/staff',
    name: 'staff-list',
    component: StaffList,
  },
  {
    path: '/staff/editor',
    name: 'staff-editor',
    component: StaffEditor,
  },
  {
    path: '/staff/:id',
    name: 'staff-detail',
    component: StaffDetail,
  },
  {
    path: '/filmcodeinspector',
    name: 'filmcodeinspector',
    component: FilmCodeInspector,
  },
  {
    path: '/voucherinspector',
    name: 'voucherinspector',
    component: VoucherInspector,
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (!to.meta.public && !localStorage.refresh_token) {
    next({
      name: 'login',
    });
  } else if (to.meta.public) {
    next();
  } else {
    auth.init().then(() => {
      store.dispatch('global/getAutocomplete');
      next();
    });
  }
});

export default router;
